<template>
  <div class="d-flex">
    <b-container fluid class="p-0 h-75px">
      <b-row no-gutters>
        <b-col cols="4" class="pr-3">
          <v-select
            label="Service"
            v-model="rule.type_id"
            :items="options"
            item-text="name"
            item-value="id"
            dense
            outlined
          />
        </b-col>
        <template v-if="selectedOption.type == 'multipleSelect'">
          <b-col cols="4" class="pr-3">
            <v-select
              v-model="rule.condition"
              label="Condition"
              :items="operators.conditions"
              item-text="text"
              item-value="index"
              dense
              outlined
              :error-messages="conditionErrors"
              @blur="$v.rule.condition.$touch()"
            />
          </b-col>

          <b-col cols="4" class="pr-3">
            <v-autocomplete
              :disabled="currentRuleCondition === 3"
              v-model="rule.options"
              class="multi-select"
              outlined
              label="Options"
              :items="ruleOperatorOptions"
              item-text="text"
              item-value="index"
              multiple
              deletable-chips
              clearable
              chips
              small-chips
              dense
              :return-object="false"
              :error-messages="optionsErrors"
              @blur="$v.rule.options.$touch()"
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                  v-if="item === Object(item)"
                  v-bind="attrs"
                  :input-value="selected"
                  label
                  small
                >
                  <span class="pr-2">
                    {{ item.text }}
                  </span>
                  <v-icon small @click="parent.selectItem(item)">
                    $delete
                  </v-icon>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="
                        ruleOperatorOptions.length > 0 ? 'purple darken-2' : ''
                      "
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> Select All </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
            <!-- <v-select
              v-model="rule.options"
              label="Options"
              :items="ruleOperatorOptions"
              item-text="text"
              item-value="index"
              dense
              outlined
              multiple
              :error-messages="optionsErrors"
              @blur="$v.rule.options.$touch()"
            /> -->
          </b-col>
        </template>
        <template
          v-else-if="
            selectedOption.type === 'inputTextMultiple' &&
            rule?.options?.length > 0
          "
        >
          <b-col
            cols="4"
            class="pr-3"
            v-for="(opt, index) in selectedOption.options"
            :key="index"
          >
            <template v-if="opt.type === 'date'">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-x
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="rule.options[index][opt.index]"
                    :label="opt.text"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                  <!--                  :error-messages="date_rangeErrors"-->
                  <!--                  @input="$v.rule[opt.index].$touch()"-->
                  <!--                  @blur="$v.rule[opt.index].$touch()"-->
                </template>
                <v-date-picker
                  v-model="rule.options[index][opt.index]"
                  @change="dateMenu = false"
                />
              </v-menu>
              <!--              <v-date-picker-->
              <!--                v-model="rule[opt.index]"-->
              <!--                range-->
              <!--                clearable-->
              <!--                :max="new Date().toISOString().split('T')[0]"-->
              <!--              />-->
            </template>
            <template v-else-if="opt.type === 'text'">
              <v-text-field
                v-model="rule.options[index][opt.index]"
                :label="opt.text"
                dense
                outlined
              />
            </template>
          </b-col>
          <!--          <b-col-->
          <!--            cols="6"-->
          <!--            class="pr-3"-->
          <!--            v-if="rule[selectedOption[1].type] === 'text'"-->
          <!--          >-->
          <!--            <v-text-field-->
          <!--              v-model="rule[selectedOption[1].index]"-->
          <!--              :label="rule[selectedOption[1].text]"-->
          <!--              dense-->
          <!--              outlined-->
          <!--              :error-messages="conditionErrors"-->
          <!--              @blur="$v.rule.value.$touch()"-->
          <!--            />-->
          <!--          </b-col>-->
        </template>
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { SET_SERVICE_NOT_VALID } from "@/core/services/store/clients.module";

export default {
  name: "Action",
  mixins: [validationMixin],
  validations: {
    rule: {
      options: {
        required: requiredIf(function () {
          return this.currentRuleCondition != 3;
        }),
      },
      condition: { required },
    },
  },
  props: {
    rule: {
      type: Object || undefined,
      required: true,
    },
    options: {
      type: Array,
    },
    userId: {
      required: false,
    },
    operators: {
      required: true,
      type: Object,
    },
  },
  data: function () {
    return {
      dateMenu: false,
    };
  },
  computed: {
    selectedOption() {
      return this.options.find((option) => option.id === this.rule.type_id);
    },
    currentRuleID: function () {
      return this.rule.type_id;
    },
    currentRuleCondition() {
      return this.rule.condition;
    },
    ruleOperatorOptions: function () {
      const options = this.options.find(
        (option) => option.id == this.rule.type_id
      ).options;
      return options;
    },
    opLabel() {
      return this.options.find((option) => option.id == this.rule.type_id).name;
    },
    optionsErrors: function () {
      return this.handleFormValidation("options", this, "rule");
    },
    conditionErrors: function () {
      return this.handleFormValidation("condition", this, "rule");
    },
    selectedAll() {
      return this.ruleOperatorOptions.length === this.rule.options.length;
    },
    selectedSome() {
      return this.ruleOperatorOptions.length > 0 && !this.selectedAll;
    },
    icon() {
      if (this.selectedAll) return "mdi-close-box";
      if (this.selectedSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    selectAllOptions() {
      this.rule.options = this.ruleOperatorOptions.map((value) => value.index);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.rule.options = [];
        } else {
          this.selectAllOptions();
        }
      });
    },
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push("This field is required");
      }
      if ("maxValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].maxValue &&
          errors.push("This field must be greater than 0");
      }
      if ("url" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].url &&
          errors.push("This url is invalid");
      }
      if ("numeric" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].numeric &&
          errors.push("This must be a number");
      }
      if ("email" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].email &&
          errors.push("This email address is invalid");
      }
      return errors;
    },

    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
    },
  },
  watch: {
    currentRuleID: function (value) {
      if (value === 8) {
        this.selectedOption.options.forEach((option) =>
          this.rule.options.push({ [option.index]: null })
        );
      } else this.rule.options = [];
      this.rule.condition = null;
    },
    currentRuleCondition: function () {
      if (this.rule.condition === 1) {
        this.selectAllOptions();
      } else if (this.rule.condition === 3) {
        this.rule.options = [];
      }
    },
    rule: {
      handler(val) {
        // console.log("handler", val);
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit(SET_SERVICE_NOT_VALID, true);
        } else {
          this.$store.commit(SET_SERVICE_NOT_VALID, false);
        }
      },
      deep: true,
    },
  },
};
</script>
